export default {
     data () {
    return {
      tabServices: null,
      text: 'chargement en cours...',
      services: [],
      existService: false,
      currentTab:null,
      serviceSelected:null,
      offreSelected:null,
      optionsList:[],
      modelSlideOffres: null,
      modelSlideOptions: null,
      activeBtnNav: 1,
      lat:null,
      lon:null,
      filtreCableGamme3P: true,
      filtreCableLabox: true,
      filtreCohesionNumerique: false,
      dialogCohesionNumerique: false,
      attCohesionNum: [],
      valideAttCohesionNum: false
    }
  },
  mounted: async function () {
  
    await this.clearOffreOptionsSession();
    await this.getEligibilite();
    this.initOffreOptionsSelectedfromSession();
    this.attCohesionNum = [];
  },

  methods: {
    getEligibilite: async function(){
      

      //récuperation dans la session
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription != null && sessionSouscription.eligibilite && sessionSouscription.eligibilite.service){
        this.$root.progress = false;

        //this.services = sessionSouscription.eligibilite.service;
        this.services[0] = sessionSouscription.serviceChoisi;

        this.existService = true;
        this.serviceSelected = this.services[0];
        this.currentTab = 0
      }else{
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }

    },
  initSelectedService: function(service){    
    
    this.serviceSelected = service;
    this.offreSelected = null;
    this.optionsList = [];

    if(this.filtreCohesionNumerique) {
      this.dialogCohesionNumerique = true;
    } else {
      this.dialogCohesionNumerique = false;
    }
    
  },
  choisirOffre: function(offre){
    this.serviceSelected.tab = this.currentTab;
    this.offreSelected = offre;
    this.optionsList = [];
  },
  /*addToOptionsList:function(option){
    this.optionsList.push(option);

  },*/
  addToOptionsList(option) {
    // Supprime toutes les options existantes du même type
    // dont multiple est false dans la liste actuelle
    this.optionsList = this.optionsList.filter(
      opt => !(opt.type === option.type && opt.multiple === false)
    );

    // Ajoute la nouvelle option
    this.optionsList.push(option);
  },
  isOffreActive: function(offre){
    if(!this.offreSelected)
      return false
    else
      return offre.id === this.offreSelected.id
  },
  filtrageOffre: function(type, offre) {
    var show1 = true;
    var show2 = true;
    var show = true;
    if(type == 'cable') {
      show1 = ((offre.gamme == 'CBOX' && this.filtreCableGamme3P) || (!offre.gamme == 'CBOX' && !this.filtreCableGamme3P) ? true : false);
      show2 = ((offre.nom.includes('LaBox') && this.filtreCableLabox) || (!offre.nom.includes('LaBox') && !this.filtreCableLabox) ? true : false);
      show = show1 && show2;

    } else if(type == 'wttx') {
      show = ((offre.gamme.substr(-2)=='CN' && this.filtreCohesionNumerique) || (offre.gamme.substr(-2)!='CN' && !this.filtreCohesionNumerique) ? true : false);

    } else {
      show = true;
    }
    return show;
  },
  isOptionActive:function(option){
    /*if(this.optionsList.length == 0)
      return false;
    const index = this.optionsList.indexOf(option);
    if (index > -1) 
      return true;
    else
      return false;*/
    if(this.optionsList.length == 0)
      return false;
      /*this.optionsList.forEach(opt => {
         return opt.id == option.id;
        });*/
    var exist = false;
    for (var item in this.optionsList) {
        if(this.optionsList[item].id == option.id)
          exist = true;
      }
      return exist;
  },
  NbOptionSel:function(option){
    if(this.optionsList.length == 0)
      return 0;
    var nbopt = false;
    for (var item in this.optionsList) {
        if(this.optionsList[item].id == option.id)
        nbopt++;
      }
      return nbopt;
  },
  removeFromOptionsList:function(option){

    for (var item in this.optionsList) {
      if(this.optionsList[item].id == option.id) {
        this.optionsList.splice(item, 1);
        break;  // pour ne pas enlever d'un coup toutes les options d'un meme id
      }
    }
  },

  validationChoixOffreOptions(){
    if(this.offreSelected == null){
      /*this.$dialog.warning({
        text: 'Vous devez choisir une offre',
        title: 'Offre obligatoire',
        persistent: true
      });*/
      this.$dialog.notify.warning('Vous devez choisir une offre', {
        position: 'bottom',
        timeout: 5000
      });
      return;
    }
    if(this.serviceSelected.type!='ftth' && this.serviceSelected.type!='cable' && this.serviceSelected.type!='wttx' ) {
      this.$dialog.notify.info('Les offres '+this.serviceSelected.type+' ne sont pas encore disponibles à la souscription par cette application. Veuillez rediriger le client en boutique', {
        position: 'bottom',
        timeout: 5000
      });
    } else {
      const serviceOffre = {"ftth":"FTH", "adsl":"INT", "cable":"CTV", "4gbox":"WTX", "wttx":"WTX" };
      const listeServices = ['ftth', 'adsl', 'cable', '4gbox', 'wttx'];

      if(listeServices.includes(this.serviceSelected.type) && serviceOffre[this.serviceSelected.type] != this.offreSelected.type) {
        this.$dialog.notify.warning("L'offre choisie ("+ this.offreSelected.nomCommercial +") ne correspond pas au service "+ this.serviceSelected.type +". Veuillez sélectionner une autre offre", {
          position: 'bottom',
          timeout: 15000
        });
      } else {

        if(this.offreSelected == null){
          /*this.$dialog.warning({
            text: 'Vous devez choisir une offre',
            title: 'Offre obligatoire',
            persistent: true
          });*/
          this.$dialog.notify.warning('Vous devez choisir une offre', {
            position: 'bottom',
            timeout: 5000
          });
        }else{

          //ajout ddu service.
          const sessionSouscriptionServiceChoisi = this.$globalService.setSessionSouscription('serviceChoisi',this.serviceSelected);
          if(sessionSouscriptionServiceChoisi == null || !sessionSouscriptionServiceChoisi.serviceChoisi){
            this.$dialog.error({
              text: "Une erreur s'est produite",
              title: 'Erreur',
              persistent: false,
              actions: {
                false: 'Fermer'
              }
            })
            return;
          }
          //ajout de loffre en session.
          const sessionSouscriptionOffreChoisie = this.$globalService.setSessionSouscription('offreChoisie',this.offreSelected);
          if(sessionSouscriptionOffreChoisie == null || !sessionSouscriptionOffreChoisie.offreChoisie){
            this.$dialog.error({
              text: "Une erreur s'est produite",
              title: 'Erreur',
              persistent: false,
              actions: {
                false: 'Fermer'
              }
            })
            return;
          }

          //ajout des options en session
          
            const sessionSouscription = this.$globalService.setSessionSouscription('optionsChoisies',this.optionsList);
            if(sessionSouscription == null || !sessionSouscription.optionsChoisies){
              this.$dialog.error({
                text: "Une erreur s'est produite",
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
              return;
            }

          // ajout attestation cohesion numérique
          if(this.serviceSelected.type=='wttx') {
            const sessionSouscription = this.$globalService.setSessionSouscription('attCohesionNumerique',(this.filtreCohesionNumerique ? 'O': 'N'));
            if(sessionSouscription == null || !sessionSouscription.attCohesionNumerique){
              this.$dialog.error({
                text: "Une erreur s'est produite",
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
              return;
            }
          }
        
          this.$router.push({name: 'PortaFixe'});

        }
      }
    }

  },
  clearOffreOptionsSession: function(){
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(sessionSouscription != null){
      delete sessionSouscription.doccli_id;
      delete sessionSouscription.sdkwebScan;
      delete sessionSouscription.souscriptionId;
      delete sessionSouscription.webflow_signature_url;

      if( sessionSouscription.offreChoisie)
        delete sessionSouscription.offreChoisie;

      if(sessionSouscription.optionsChoisies)
        delete sessionSouscription.optionsChoisies;

        if(sessionSouscription.attCohesionNumerique)
        delete sessionSouscription.attCohesionNumerique;

      this.$globalService.setSessionStorageId('souscription', sessionSouscription);
    }
  },
  initOffreOptionsSelectedfromSession: function(){
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(sessionSouscription != null){
      this.lat=sessionSouscription.eligibilite.lat;
      this.lon=sessionSouscription.eligibilite.lon;
      if( sessionSouscription.serviceChoisi){
        this.serviceSelected =  sessionSouscription.serviceChoisi;
        this.currentTab = this.serviceSelected.tab;
      }
      if( sessionSouscription.offreChoisie)
        this.offreSelected =  sessionSouscription.offreChoisie;

      if(sessionSouscription.optionsChoisies)
        this.optionsList =  sessionSouscription.optionsChoisies;
    }
    //await this.$nextTick()
  },

   goToCarto:function(){
    this.$router.push({name: 'Carto',query: { lat: this.lat, lon:this.lon }});
   },

   annuleCohesionNumerique: function() {
    this.filtreCohesionNumerique=false;
    this.dialogCohesionNumerique=false;
    this.valideAttCohesionNum = false;
    this.attCohesionNum = [];
   },

   checkAttCohesionNumerique: function() {
     //cases à cochées obligatoires :
     if(this.attCohesionNum.includes("1") && this.attCohesionNum.includes("2")) {
      this.valideAttCohesionNum = true;
     } else {
      this.valideAttCohesionNum = false;
     }
   }

  }

}